import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
var getValueLinkProps = function getValueLinkProps(props) {
  return _.has(props, 'valueLink') ? {
    value: props.valueLink.value,
    onChange: props.valueLink.requestChange
  } : {};
};
var createWithUtils = function createWithUtils(innerComp) {
  var Component = function Component(props) {
    var getClassName = function getClassName(defaultClassName) {
      var propName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'className';
      return [defaultClassName, props[propName]].join(' ');
    };
    var valueLinkProps = getValueLinkProps(props);
    var dataHook = props.dataHook || props.automationId;
    var dataHooks = dataHook ? {
      dataHook: dataHook
    } : {};
    var newProps = _({}).assign(props, dataHooks, {
      getClassName: getClassName
    }, valueLinkProps).omit(['valueLink']).value();
    return /*#__PURE__*/React.createElement(innerComp, newProps);
  };
  Component.displayName = innerComp.displayName;
  return Component;
};
createWithUtils.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string
};
createWithUtils.defaultProps = {
  automationId: null,
  dataHook: ''
};
export default createWithUtils;